import login from "@mochi/misc/auth/login/redux";
import { reducer as homeScreen } from "../home-screen/redux/reducer";
import { reducer as registerRoom } from "../register-room/redux/reducer";
import { reducer as bookingCalendar } from "../booking-calendar/redux/reducer";
import { reducer as registerOption } from "../register-option/redux/reducer";
import { reducer as bookingConfirm } from "../booking-information/redux/reducer";
import { reducer as rebookingConfirm } from "../rebook-overview/redux/reducer";
import { reducer as maintenance } from "../maintenance-page/redux/reducer";

export const reducers = {
  login,
  homeScreen,
  registerRoom,
  bookingCalendar,
  registerOption,
  bookingConfirm,
  rebookingConfirm,
  maintenance
};
